import $ from 'jquery';

/**
 * TOP: 物件種別から検索方法モーダル（Magnific Popup + searchMethod__nav）
 */
const MODALS = [
	{
		trigger: '.js-top-new-house-modal-trigger',
		src: '#top-new-house-modal',
		close: '.js-top-new-house-modal-close',
		dataKey: 'topSearchTypeMfpNewHouse',
	},
	{
		trigger: '.js-top-used-house-modal-trigger',
		src: '#top-used-house-modal',
		close: '.js-top-used-house-modal-close',
		dataKey: 'topSearchTypeMfpUsedHouse',
	},
	{
		trigger: '.js-top-used-mansion-modal-trigger',
		src: '#top-used-mansion-modal',
		close: '.js-top-used-mansion-modal-close',
		dataKey: 'topSearchTypeMfpUsedMansion',
	},
	{
		trigger: '.js-top-land-modal-trigger',
		src: '#top-land-modal',
		close: '.js-top-land-modal-close',
		dataKey: 'topSearchTypeMfpLand',
	},
];

function bindModal({ trigger, src, close, dataKey }) {
	const triggerEl = document.querySelector(trigger);
	const modalEl = document.querySelector(src);
	if (!(triggerEl instanceof HTMLElement) || !(modalEl instanceof HTMLElement)) return;
	if (triggerEl.dataset[dataKey] === 'true') return;

	const closeButton = modalEl.querySelector(close);
	if (closeButton instanceof HTMLButtonElement) {
		closeButton.addEventListener('click', () => {
			$.magnificPopup.close();
		});
	}

	const setupPopup = () => {
		$(triggerEl).magnificPopup({
			items: {
				src,
				type: 'inline',
			},
			closeBtnInside: true,
			mainClass: 'top-search-type-modal-popup',
		});
	};

	if ($.fn.magnificPopup) {
		setupPopup();
		triggerEl.dataset[dataKey] = 'true';
	} else {
		import('magnific-popup/dist/jquery.magnific-popup.js').then(() => {
			setupPopup();
			triggerEl.dataset[dataKey] = 'true';
		});
	}
}

export function init() {
	if (!document.body.classList.contains('is-top')) return;

	MODALS.forEach(bindModal);
}
